import { LightModeRounded, ModeNightRounded, KeyboardArrowUpRounded, KeyboardArrowDownRounded, KeyboardArrowRightRounded, KeyboardBackspaceRounded, FiberSmartRecordRounded, RemoveRounded, CloudUploadRounded, DoneAllRounded, DownloadRounded, MenuRounded, CloseRounded, Twitter, Instagram, PhotoRounded, FacebookRounded, WhatsApp, Telegram, Mail, LocationOn, LinkRounded, CallRounded, EmailRounded, SearchRounded, ShutterSpeedRounded, NoteAltRounded, NetworkPingRounded, PeopleRounded, Visibility, VisibilityOff, PasswordRounded, BlockRounded, CheckCircleOutlineRounded, ProductionQuantityLimitsRounded, Business, LocalConvenienceStoreRounded, DesignServicesRounded, StarOutlineRounded, StarRateRounded, AddShoppingCartRounded, ShoppingBasketRounded, DeleteOutlineRounded, AddRounded, PaymentsRounded, LocalShippingRounded, ShoppingCartCheckoutRounded, FavoriteBorderRounded, FavoriteRounded, MarkEmailReadRounded, LockRounded, AddBoxRounded, PageviewRounded, EditRounded, VisibilityRounded, NotificationsNoneRounded, DeleteRounded, PersonRounded, AccountBoxRounded, HourglassEmptyRounded, SupportAgentRounded, ShareRounded, SchoolRounded, AccountBalanceRounded, RocketLaunchRounded, PublicRounded, FlightRounded, DeliveryDiningRounded }  from '@mui/icons-material'

import { airbnb, content, google, marketing, microsoft, social, emailPromotion, emailMarketing, img1, img5, img4, img2, img3, nurse, physicalTherapy, speech, medicalExamination, medicalHistory, occupationalTherapy } from '../assets';

export { LightModeRounded, ModeNightRounded, KeyboardArrowUpRounded, KeyboardArrowDownRounded, KeyboardArrowRightRounded, KeyboardBackspaceRounded, FiberSmartRecordRounded, RemoveRounded, CloudUploadRounded, DoneAllRounded, DownloadRounded, MenuRounded, CloseRounded, Twitter, Instagram, PhotoRounded, FacebookRounded, WhatsApp, Telegram, Mail, LocationOn, LinkRounded, CallRounded, EmailRounded, SearchRounded, ShutterSpeedRounded, NoteAltRounded, NetworkPingRounded, PeopleRounded, Visibility, VisibilityOff, PasswordRounded, BlockRounded, CheckCircleOutlineRounded, ProductionQuantityLimitsRounded, Business, LocalConvenienceStoreRounded, DesignServicesRounded, StarOutlineRounded, StarRateRounded, AddShoppingCartRounded, ShoppingBasketRounded, DeleteOutlineRounded, AddRounded, PaymentsRounded, LocalShippingRounded, ShoppingCartCheckoutRounded, FavoriteBorderRounded, FavoriteRounded, MarkEmailReadRounded, LockRounded, AddBoxRounded, PageviewRounded, EditRounded, VisibilityRounded, NotificationsNoneRounded, DeleteRounded, PersonRounded, AccountBoxRounded, HourglassEmptyRounded, SupportAgentRounded, ShareRounded, SchoolRounded, AccountBalanceRounded, RocketLaunchRounded, PublicRounded }


export const navLinks = [
  { name: 'home', link: '/'},
  { name: 'posts', link: '/posts'},
  { name: 'items', link: '/items'},
  { name: 'services', link: '/services'},
  // { name: 'extras'},
]

export const companyLogos = [
  {name: 'google', icon: google},
  {name: 'airbnb', icon: airbnb},
  {name: 'microsoft', icon: microsoft},
]

export const disabilityServicesList = [
  {
    title: "In-Home and community support",
  },
  {
    title: "Nursing services",
  },
  {
    title: "Behavioral support services",
  },
  {
    title: "Day Habilitation",
  },
  {
    title: "Respite Care",
  },
  {
    title: "Support Employment / Job coaching",
  },
]

export const genderOptions = [
    {name: "male"},
    {name: "female"},
]

export const personalizedCare = [
  {
    question: "Skilled Nursing Services",
    answer: "Professional Nurses provide clinical care, medication management and recovery support at home.",
  },
  {
    question: "Physical and occupational Therapy",
    answer: "Restores mobility, strength and independence after illness or injury. Helps clients regain daily living skills and adapt safely at home",
  },
  {
    question: "Chronic Care",
    answer: "Supports long-term management of diabetes, heart disease and more...",
  },
];

export const servicesData = [ 
  {
    title: "Skilled Nursing Services",
    description: "Our RNs and LVs provide expert clinical care, including medication management, wound care, and chronic disease support. We help patients recover safely at home under physician-guided plans of care.",
    icon: nurse,
  },

  {
    title: "Physical Therapy",
    description: "Our physical therapists restore strength, mobility, and balance after illness, surgery, or injury. Each program is tailored to improved independence and reduce the risks of fails",
    icon: physicalTherapy,
  },

  {
    title: "Occupational Therapy",
    description: "We help clients regain the skills needed for daily living activities like dressing, bathing, and cooking. Our therapists recommend adaptive technique and home safety modifications.",
    icon: occupationalTherapy,
  },

  {
    title: "Speech Therapy",
    description: "Speech-languages pathologists treat communication, cognitive, and swallowing disorders. We help patients regain speech clarity, comprehension and confidence.",
    icon: speech,
  },

  {
    title: "Medical Social Services",
    description: "Our licensed social workers connect clients with community resources and emotional support. We guide families through care planning, financial assistance, and crisis intervention.",
    icon: medicalExamination,
  },

  {
    title: "Medication Management & Education",
    description: "Nurses provided medication setup, teaching, and adherence monitoring. We help patients understand prescriptions and manage medications safely",
    icon: medicalHistory,
  },
]

export const meetTeamData = [
  {
    name: "Adeleke Johnson",
    title: "CEO & Founder",
    image: img1,
  },
  {
    name: "Cliarke Mary",
    title: "CEO & Founder",
    image: img5,
  },
  {
    name: "Funsho David",
    title: "CEO & Founder",
    image: img4,
  },
  {
    name: "Chiamaka Oyemike",
    title: "CEO & Founder",
    image: img2,
  },
  {
    name: "Margaret Aisha",
    title: "CEO & Founder",
    image: img3,
  },
  {
    name: "Adeleke Johnson",
    title: "CEO & Founder",
    image: img4,
  },
]


export const faqs = [
    {
      id: 0,  
      header: "how do i navigate market place profile ?",
      text: "Velit ipsum amet minim laborum voluptate aliquip fugiat enim ipsum sit sunt. Excepteur tempor ad sit commodo ut occaecat cillum tempor nisi in. Mollit dolore eiusmod aliqua irure laborum amet laboris. Enim nostrud anim ut velit aliquip ad quis irure fugiat ex aliqua aliqua elit. Ipsum officia sit quis sint. Anim enim qui qui do duis qui consequat cillum."
    },
    {
      id: 1,
      header: "how do i contact customer support ?",
      text: "Velit ipsum amet minim laborum voluptate aliquip fugiat enim ipsum sit sunt. Excepteur tempor ad sit commodo ut occaecat cillum tempor nisi in. Mollit dolore eiusmod aliqua irure laborum amet laboris. Enim nostrud anim ut velit aliquip ad quis irure fugiat ex aliqua aliqua elit. Ipsum officia sit quis sint. Anim enim qui qui do duis qui consequat cillum. Enim nostrud anim ut velit aliquip ad quis irure fugiat ex aliqua aliqua elit. Ipsum officia sit quis sint. Anim enim qui qui do duis qui consequat cillum Enim nostrud anim ut velit aliquip ad quis irure fugiat ex aliqua aliqua elit. Ipsum officia sit quis sint. Anim enim qui qui do duis qui consequat cillum"
    },
    {
      id: 2,
      header: "Is my email address visible to others ?",
      text: "Velit ipsum amet minim laborum voluptate aliquip fugiat enim ipsum sit sunt. Excepteur tempor ad sit commodo ut occaecat cillum tempor nisi in. Mollit dolore eiusmod aliqua irure laborum amet laboris. Enim nostrud anim ut velit aliquip ad quis irure fugiat ex aliqua aliqua elit. Ipsum officia sit quis sint. Anim enim qui qui do duis qui consequat cillum."
    },
    {
      id: 3,
      header: "Is my email address visible to others ?",
      text: "Velit ipsum amet minim laborum voluptate aliquip fugiat enim ipsum sit sunt. Excepteur tempor ad sit commodo ut occaecat cillum tempor nisi in. Mollit dolore eiusmod aliqua irure laborum amet laboris. Enim nostrud anim ut velit aliquip ad quis irure fugiat ex aliqua aliqua elit. Ipsum officia sit quis sint. Anim enim qui qui do duis qui consequat cillum."
    },
    {
      id: 4,
      header: "Is my email address visible to others ?",
      text: "Velit ipsum amet minim laborum voluptate aliquip fugiat enim ipsum sit sunt. Excepteur tempor ad sit commodo ut occaecat cillum tempor nisi in. Mollit dolore eiusmod aliqua irure laborum amet laboris. Enim nostrud anim ut velit aliquip ad quis irure fugiat ex aliqua aliqua elit. Ipsum officia sit quis sint. Anim enim qui qui do duis qui consequat cillum."
    }
]

export const featuresList = [
    {id: 1, icon: PublicRounded, title: 'Global Sourcing.', detail: 'Hexagon China helps businesses source quality products directly from China.'},
    {id: 2, icon: FlightRounded, title: 'We make China sourcing sample.', detail: '3-layer quality inspections before shipping'},
    {id: 3, icon: LocalShippingRounded, title: 'Africa-friendly services', detail: 'Seamless door-to-door shipping and customs handling'},
]

